import { apiClient } from '@/shared/api/apiClient';
import { handleRequest } from '@/shared/api/apiWrapper';
import type { OperationsListResponseDto } from '@/shared/types';

export const getOperationsHistory = async (filter: string) => {
  const request = () => apiClient.get(`/operations/list/${filter}`);
  const response = await handleRequest<OperationsListResponseDto>(request);
  return response.data;
};

export const getOperationsDelta = async (filterWithQuery: string) => {
  const request = () =>
    apiClient.get(`/operations/list/delta/${filterWithQuery}`);
  const response = await handleRequest<OperationsListResponseDto>(request);
  return response.data;
};
